var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 19.2399C36 8.9663 27.9422 0.639893 18 0.639893C8.05781 0.639893 0 8.9663 0 19.2399C0 28.5254 6.58125 36.2197 15.1875 37.6147V24.6165H10.6172V19.2399H15.1875V15.1421C15.1875 10.4812 17.8734 7.90552 21.9867 7.90552C23.9555 7.90552 26.0156 8.2688 26.0156 8.2688V12.8461H23.7445C21.5086 12.8461 20.8125 14.2811 20.8125 15.7524V19.2399H25.8047L25.0066 24.6165H20.8125V37.6147C29.4188 36.2197 36 28.5254 36 19.2399Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0066 24.6165L25.8047 19.2399H20.8125V15.7524C20.8125 14.2811 21.5086 12.8461 23.7445 12.8461H26.0156V8.2688C26.0156 8.2688 23.9555 7.90552 21.9867 7.90552C17.8734 7.90552 15.1875 10.4812 15.1875 15.1421V19.2399H10.6172V24.6165H15.1875V37.6147C16.1051 37.7636 17.0437 37.8399 18 37.8399C18.9563 37.8399 19.8949 37.7636 20.8125 37.6147V24.6165H25.0066Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 37.2,
    fill: "white",
    transform: "translate(0 0.639893)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMobile);
export default __webpack_public_path__ + "static/media/facebook-mobile.c5ed3beabd18059bc6c2e2a5c38f8c25.svg";
export { ForwardRef as ReactComponent };